import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'app-info-button-tooltip',
  imports: [
    MatTooltipModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './info-button-tooltip.component.html',
  styleUrl: './info-button-tooltip.component.scss'
})
export class InfoButtonTooltipComponent {
  tooltipText = input<string>('');
  tooltipPosition = input<TooltipPosition>('above');
}
